import { Flex, Skeleton, Stack } from "@chakra-ui/react";

const LoadingTabCliente: React.FC = () => {
	return (
		<Flex w="100%" mt={4}>
			<Stack w="100%">
				<Skeleton w="60%" height='30px' borderRadius="full" />

				<Stack>
					<Skeleton mt={4} w="30%" height='25px' borderRadius="full" />
					<Skeleton height='30px' borderRadius="full" />
				</Stack>

				<Stack>
					<Skeleton mt={4} w="30%" height='25px' borderRadius="full" />
					<Skeleton height='30px' borderRadius="full" />
				</Stack>

				<Stack>
					<Skeleton mt={4} w="30%" height='25px' borderRadius="full" />
					<Skeleton height='30px' borderRadius="full" />
				</Stack>

				<Stack>
					<Skeleton mt={4} w="30%" height='25px' borderRadius="full" />
					<Skeleton height='30px' borderRadius="full" />
				</Stack>

				<Stack>
					<Skeleton mt={4} w="30%" height='25px' borderRadius="full" />
					<Skeleton height='30px' borderRadius="full" />
				</Stack>
			</Stack>
		</Flex>
	)
};

export default LoadingTabCliente;